module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/HeatStress/Kanagawa_HeatStress_GFDL_RCP26_Mid.png";